/**
 * DDM Quantity Variant Auto-Selection
 *
 * Watches the standard (- N +) quantity selector and auto-selects the correct
 * pricing tier variant. Visual updates (highlight + total) happen immediately;
 * the actual variant switch (hidden radio click) is debounced.
 *
 * After the radio click triggers a variant picker morph, scheduled re-applies
 * restore our state (the morph replaces our DOM with server-rendered defaults).
 */
(function () {
  'use strict';

  var MONEY_FORMAT = '${{amount}}';
  try {
    if (window.Theme && window.Theme.moneyFormat) {
      MONEY_FORMAT = window.Theme.moneyFormat;
    }
  } catch (e) { /* ignore */ }

  var debounceTimer = null;
  var reapplyTimers = [];

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MONEY_FORMAT
      .replace('{{amount}}', amountWithCommas)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100).toString())
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}',
        Math.round(cents / 100).toString());
  }

  function parseTierData() {
    var script = document.querySelector('script[data-ddm-quantity-tier-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent).map(function (t) {
        return {
          quantity: parseInt(t.quantity, 10),
          priceCents: t.priceCents,
          priceFormatted: t.priceFormatted,
          variantId: t.variantId
        };
      });
    } catch (e) {
      return null;
    }
  }

  function findBestTier(tiers, qty) {
    var best = tiers[0];
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].quantity) best = tiers[i];
    }
    return best;
  }

  function highlightActiveTier(activeQty) {
    var rows = document.querySelectorAll('[data-ddm-tier-qty]');
    for (var i = 0; i < rows.length; i++) {
      var tierQty = parseInt(rows[i].getAttribute('data-ddm-tier-qty'), 10);
      if (tierQty === activeQty) {
        rows[i].classList.add('ddm-quantity-tiers__row--active');
      } else {
        rows[i].classList.remove('ddm-quantity-tiers__row--active');
      }
    }
  }

  function updateTotalDisplay(qty, tier) {
    var calcEl = document.getElementById('ddm-price-calculation');
    var totalEl = document.getElementById('ddm-total-price');
    if (!calcEl || !totalEl) return;
    calcEl.textContent = qty + ' \u00d7 ' + tier.priceFormatted;
    totalEl.textContent = formatMoney(qty * tier.priceCents);
  }

  function selectTierInPicker(fieldset, tierValue) {
    if (!fieldset) return;
    var radio = fieldset.querySelector('input[type="radio"][value="' + tierValue + '"]');
    if (radio && !radio.checked) {
      radio.click();
    }
  }

  function setFormVariantId(tier) {
    if (!tier.variantId) return;
    var input = document.querySelector('product-form-component input[name="id"]');
    if (input) input.value = tier.variantId;
  }

  function enableAddToCart() {
    var btn = document.querySelector('product-form-component [ref="addToCartButton"]');
    if (btn) btn.disabled = false;
  }

  /**
   * Submit a form, letting the theme's handler process it.
   * Sets a flag so our capture-phase listener skips the intercept.
   */
  function submitFormToTheme(form) {
    form._ddmConsolidating = true;
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    }
    form._ddmConsolidating = false;
  }

  /**
   * Intercept form submit to consolidate cart line items across tiers.
   *
   * Without this, adding qty=1 then qty=2 creates two separate line items
   * (1 × base-tier + 2 × tier-2) instead of one (3 × tier-2).
   *
   * Flow:
   *  1. Capture-phase listener fires before the theme's handler
   *  2. Fetch current cart to check for existing tier items
   *  3. If none exist, let the theme handle normally
   *  4. If consolidation needed: clear existing tier items via /cart/update.js,
   *     set form to correct tier + total qty, then re-submit to the theme
   */
  function interceptFormSubmit(tiers) {
    var form = document.querySelector('product-form-component form');
    if (!form || form._ddmTierBound) return;
    form._ddmTierBound = true;

    // Build set of all tier variant IDs for quick lookup
    var tierVariantIdSet = {};
    for (var i = 0; i < tiers.length; i++) {
      if (tiers[i].variantId) {
        tierVariantIdSet[tiers[i].variantId.toString()] = true;
      }
    }

    // Track whether the cart already has tier items for this product.
    // Only intercept submits when consolidation is actually needed.
    var cartHasTierItems = false;

    // Pre-check cart on page load (non-blocking)
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        for (var i = 0; i < cart.items.length; i++) {
          if (tierVariantIdSet[cart.items[i].variant_id.toString()]) {
            cartHasTierItems = true;
            break;
          }
        }
      })
      .catch(function () { /* ignore */ });

    form.addEventListener('submit', function (event) {
      // Skip if re-submitting after consolidation
      if (form._ddmConsolidating) return;

      // If no tier items in cart yet, let theme handle normally (no interception).
      // After this add, the cart will have tier items for next time.
      if (!cartHasTierItems) {
        cartHasTierItems = true;
        return;
      }

      // Consolidation needed — intercept and merge line items
      var quantityInput = document.querySelector(
        'product-form-component quantity-selector-component input[ref="quantityInput"]'
      );
      var addingQty = parseInt(quantityInput ? quantityInput.value : '1', 10) || 1;

      event.preventDefault();
      event.stopImmediatePropagation();

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var existingQty = 0;
          for (var i = 0; i < cart.items.length; i++) {
            var vid = cart.items[i].variant_id.toString();
            if (tierVariantIdSet[vid]) {
              existingQty += cart.items[i].quantity;
            }
          }

          if (existingQty === 0) {
            // Cart was cleared between flag set and now — just add normally
            enableAddToCart();
            submitFormToTheme(form);
            return;
          }

          // Consolidation: single atomic /cart/update.js sets final desired state.
          // No two-step clear+add, no race conditions.
          var totalQty = existingQty + addingQty;
          var bestTier = findBestTier(tiers, totalQty);

          var updates = {};
          for (var vid in tierVariantIdSet) {
            updates[vid] = 0;
          }
          updates[bestTier.variantId] = totalQty;

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
            .then(function (r) { return r.json(); })
            .then(function (response) {
              // Re-enable button (theme disabled it on variant select)
              enableAddToCart();

              // Set the form variant ID to match what's now in the cart
              setFormVariantId(bestTier);

              // Dispatch cart:update so theme refreshes cart drawer, badge, etc.
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: response,
                  data: {
                    source: 'ddm-consolidation',
                    itemCount: response.item_count
                  }
                }
              }));

              // Restore visual state for the user's entered quantity
              applyState(parseInt(quantityInput ? quantityInput.value : '1', 10) || 1, tiers);
            });
        })
        .catch(function (err) {
          console.error('DDM cart consolidation error:', err);
          // Fall back to normal add on error
          enableAddToCart();
          submitFormToTheme(form);
        });
    }, true); // capture phase fires before theme's handler
  }

  function applyState(qty, tiers) {
    var tier = findBestTier(tiers, qty);
    highlightActiveTier(tier.quantity);
    updateTotalDisplay(qty, tier);
    setFormVariantId(tier);
    enableAddToCart();
  }

  function cancelReapplies() {
    for (var i = 0; i < reapplyTimers.length; i++) {
      clearTimeout(reapplyTimers[i]);
    }
    reapplyTimers = [];
  }

  /**
   * Schedule re-applies after a radio click to restore state after morph.
   * The variant picker fetch takes ~300-800ms; multiple re-applies ensure
   * we catch the morph close to when it happens (~200ms max flash).
   */
  function scheduleReapplies(qty, tiers) {
    cancelReapplies();
    var delays = [300, 500, 800, 1200];
    for (var i = 0; i < delays.length; i++) {
      (function (d) {
        reapplyTimers.push(setTimeout(function () {
          applyState(qty, tiers);
        }, d));
      })(delays[i]);
    }
  }

  function onQuantityChange(quantityInput, tiers, fieldset) {
    var qty = parseInt(quantityInput.value, 10) || 1;
    var bestTier = findBestTier(tiers, qty);

    // Immediate visual feedback
    applyState(qty, tiers);

    // Cancel pending debounce and re-applies from previous change
    clearTimeout(debounceTimer);
    cancelReapplies();

    // Debounced variant switch (triggers fetch + morph in variant picker)
    debounceTimer = setTimeout(function () {
      selectTierInPicker(fieldset, bestTier.quantity.toString());
      // Re-apply at intervals to restore state after morph overwrites it
      scheduleReapplies(qty, tiers);
    }, 300);
  }

  function bindEvents(quantityInput, tiers, fieldset) {
    if (quantityInput._ddmBound) return;
    quantityInput._ddmBound = true;

    var handler = function () {
      onQuantityChange(quantityInput, tiers, fieldset);
    };

    quantityInput.addEventListener('input', handler);
    quantityInput.addEventListener('change', handler);

    var component = quantityInput.closest('quantity-selector-component');
    if (component) {
      component.addEventListener('quantity-selector:update', handler);
    }
  }

  function init() {
    var tiers = parseTierData();
    if (!tiers || tiers.length === 0) return;

    var fieldset = document.querySelector('.ddm-quantity-tiers__hidden-fieldset');
    if (!fieldset) return;

    var quantityInput = document.querySelector(
      'product-form-component quantity-selector-component input[ref="quantityInput"]'
    );
    if (!quantityInput) {
      setTimeout(init, 500);
      return;
    }

    bindEvents(quantityInput, tiers, fieldset);
    interceptFormSubmit(tiers);
    var qty = parseInt(quantityInput.value, 10) || 1;
    applyState(qty, tiers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init if tier data is added to the DOM (e.g., lazy section rendering)
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (n instanceof HTMLElement &&
          (n.matches && n.matches('[data-ddm-quantity-tier-data]') ||
           n.querySelector && n.querySelector('[data-ddm-quantity-tier-data]'))) {
          requestAnimationFrame(init);
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
